/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Severity level when condition is met
 */
export type CreateIncidentRuleDtoSeverity = (typeof CreateIncidentRuleDtoSeverity)[keyof typeof CreateIncidentRuleDtoSeverity];

export const CreateIncidentRuleDtoSeverity = {
  MINOR: 'minor',
  MAJOR: 'major',
  CRITICAL: 'critical',
} as const;
